/**
 * 令牌存储。
 *
 * M0 只给内存实现 —— 落地到哪里(localStorage / Capacitor Preferences)是 M1 的事，
 * 那时只要再实现一遍这个接口即可，HTTP 层不用改。
 *
 * ⚠ 令牌不进 URL、不进日志、不进埋点。
 */
export interface Tokens {
  readonly accessToken: string
  readonly refreshToken: string
  /** access 的过期时刻(epoch 毫秒)。⚠ 只用于「提前刷新」的优化，判过期仍以服务端 401 为准。 */
  readonly expiresAt: number
}

export interface TokenStore {
  get(): Tokens | null
  set(tokens: Tokens | null): void
  subscribe(listener: (tokens: Tokens | null) => void): () => void
}

/** `expiresIn`(剩余秒数) → `expiresAt`(绝对毫秒)。 */
export function toExpiresAt(expiresIn: number, now: number = Date.now()): number {
  return now + expiresIn * 1000
}

export function createMemoryTokenStore(initial: Tokens | null = null): TokenStore {
  let current = initial
  const listeners = new Set<(tokens: Tokens | null) => void>()

  return {
    get: () => current,
    set(tokens) {
      current = tokens
      for (const listener of listeners) listener(tokens)
    },
    subscribe(listener) {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
  }
}
